<template>
    <div class="shadow-md p-3">
      El usuario fue creado correctamente, <br>
      Pronto le llegara un mail de confirmación, anunciado que la cuenta fue verificada
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
      };
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    },
  };
  </script>

